//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum KEYS {
  ENTER = 'Enter',
  SHIFT = 'Shift',
  ESC = 'Escape',
}

export const KEYCODES = {
  [KEYS.ENTER]: 13,
  [KEYS.SHIFT]: 16,
  [KEYS.ESC]: 27,
};
